export const menuInfo = {
    lunch: {
        'Burgers': [{
                name: 'Bacon Cheese Burger',
                description: 'Bacon, American Cheese, and Mayo',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Bo Burger',
                description: 'Eggs, onion and cheese',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Avocado Pepperjack Burger',
                description: 'Guacamole and Pepper Jack cheese',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Southwest Black Bean Burger (V)',
                description: 'Black bean patty, pepperjack cheese, and chipotle mayo',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Impossible Burger (V)',
                description: 'Impossible patty with lettuce, tomatoes, and mayo',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
        ],
        'Salads': [{
            name: 'Build Your Own Salad',
            description: 'Customize your own salad with choice of protein and dressing',
            modifications: [{
                    'Protein': ['Chicken', 'Tuna', 'Impossible Patty', 'Black Bean Patty', 'No Protein']
                },
                {
                    'Dressings': ['Balsamic', 'Southwest', 'Ranch', 'Caesar']
                }
            ],
            restrictions: ['No Bread', 'Dairy-Free']
        }],
        'Wraps': [{
                name: 'Chicken Bacon Ranch Wrap',
                description: 'Grilled chicken, bacon, ranch dressing, cheese, and spring mix wrapped in a flour tortilla',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Buffalo Chicken Wrap',
                description: 'Grilled chicken, homemade buffalo sauce, ranch, cheddar, and spring mix wrapped in a flour tortilla',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Chicken Caesar Wrap',
                description: 'Grilled chicken, caesar dressing, and spring mix wrapped in a flour tortilla',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
        ],
        'Subs': [{
                name: 'Philly Cheesesteak Sub',
                description: 'Steak, American cheese, peppers, and onions in a hoagie roll',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Chicken Philly Sub',
                description: 'Grilled chicken, American cheese, peppers, and onions in a hoagie roll',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
        ],
        'Sandwiches': [{
                name: 'Pesto Chicken Sandwich',
                description: 'Grilled chicken, pesto, roasted red peppers, and provolone cheese',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Sliced Turkey on Rye',
                description: 'Turkey breast, Provolone Cheese, on Rye',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
            {
                name: 'Grilled Cheese Sandwich (V)',
                description: 'American Cheese, white bread',
                modifications: {},
                restrictions: ['No Bread', 'Dairy-Free']
            },
        ]
    },
    dinner: {

        'Mains': [{
                name: 'Baked Ziti',
                description: 'Ziti cooked in marinara and sausage',
                restrictions: ['Gluten-Free', 'No Dairy']
            },
            {
                name: 'Baked Ziti (Vegetarian)',
                description: 'Ziti cooked in marinara',
                restrictions: ['Gluten-Free', 'No Dairy']
            }
        ]
    }
}

export default menuInfo;